const months = [
  { monthNumber: 1, monthName: 'January', endDay: 31, startHour: 6, endHour: 21, shortName: 'Jan' },
  { monthNumber: 2, monthName: 'February', endDay: 28, startHour: 6, endHour: 21, shortName: 'Feb' },
  { monthNumber: 3, monthName: 'March', endDay: 31, startHour: 6, endHour: 20, shortName: 'Mar' },
  { monthNumber: 4, monthName: 'April', endDay: 30, startHour: 5, endHour: 20, shortName: 'Apr' },
  { monthNumber: 5, monthName: 'May', endDay: 31, startHour: 5, endHour: 20, shortName: 'May' },
  { monthNumber: 6, monthName: 'June', endDay: 30, startHour: 5, endHour: 20, shortName: 'Jun' },
  { monthNumber: 7, monthName: 'July', endDay: 31, startHour: 5, endHour: 20, shortName: 'Jul' },
  { monthNumber: 8, monthName: 'August', endDay: 31, startHour: 5, endHour: 20, shortName: 'Aug' },
  { monthNumber: 9, monthName: 'September', endDay: 30, startHour: 5, endHour: 20, shortName: 'Sep' },
  { monthNumber: 10, monthName: 'October', endDay: 31, startHour: 5, endHour: 20, shortName: 'Oct' },
  { monthNumber: 11, monthName: 'November', endDay: 30, startHour: 5, endHour: 21, shortName: 'Nov' },
  { monthNumber: 12, monthName: 'December', endDay: 31, startHour: 6, endHour: 21, shortName: 'Dec' },
];

export default months



// WEBPACK FOOTER //
// ./src/utils/months.js